import { render } from "./BoardToast.vue?vue&type=template&id=20dba31d"
import script from "./BoardToast.vue?vue&type=script&lang=js"
export * from "./BoardToast.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__